/**
 * Application entry point.
 *
 * Renders the React app and applies global styles.
 * Amplify is configured here at the top level to ensure OAuth redirect
 * callbacks are processed before any React component mounts.
 * Auth state initialization happens inside App component on mount.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { getAmplifyConfig } from './config/amplify';
import { App } from './App';
import './styles/globals.css';

// Configure Amplify at the top level before any component renders.
// This ensures OAuth redirect callbacks (auth code in URL) are properly
// processed by Amplify's internal auth module.
Amplify.configure(getAmplifyConfig());

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
